/**
 * Purview CVC Constants
 */

// Solution colors for charts - matching Purview product theme
export const SOLUTION_COLORS: Record<string, string> = {
  "DLP": "#0078D4",
  "MIP": "#00B7C3",
  "Insider Risk": "#FFB900",
  "eDiscovery": "#E3008C",
  "CommComp": "#107C10",
  "Compliance Manager": "#5C2D91",
  "Audit": "#008272",
  "Purview for AI": "#FF8C00",
  "Data Security Investigations (DSI)": "#E81123",
  "Purview Data Governance": "#004E8C",
  "Data Security Posture Management (DSPM)": "#00188F",
  "Agent 365 S4AI": "#8764B8",
  "DLM-RM": "#038387"
};

// Status colors
export const ENGAGEMENT_STATUS_COLORS: Record<string, { background: string; color: string }> = {
  "Active": { background: "linear-gradient(135deg, #059669, #047857)", color: "#FFFFFF" },
  "New": { background: "#E6E0F7", color: "#5A4796" },
  "Pending": { background: "linear-gradient(135deg, #F59E0B, #D97706)", color: "#FFFFFF" },
  "In Progress": { background: "#FDE68A", color: "#92400E" },
  "Completed": { background: "linear-gradient(135deg, #059669, #047857)", color: "#FFFFFF" },
  "Inactive": { background: "linear-gradient(135deg, #6B7280, #4B5563)", color: "#FFFFFF" }
};

// LocalStorage key prefix for filter persistence
export const CVC_FILTER_STORAGE_PREFIX = "purview-cvc-filter";

// Last Engaged time buckets
export const LAST_ENGAGED_BUCKETS = [
  { key: "1-8d", label: "1-8d", fullLabel: "Active (1-8 days)", minDays: 1, maxDays: 8, color: "#10B981" },
  { key: "9-15d", label: "9-15d", fullLabel: "Recent (9-15 days)", minDays: 9, maxDays: 15, color: "#22C55E" },
  { key: "16-23d", label: "16-23d", fullLabel: "Moderate (16-23 days)", minDays: 16, maxDays: 23, color: "#EAB308" },
  { key: "24-30d", label: "24-30d", fullLabel: "Aging (24-30 days)", minDays: 24, maxDays: 30, color: "#F97316" },
  { key: "31-59d", label: "31-59d", fullLabel: "Stale (31-59 days)", minDays: 31, maxDays: 59, color: "#EF4444" },
  { key: "60+d", label: "60+d", fullLabel: "Inactive (60+ days)", minDays: 60, maxDays: Infinity, color: "#991B1B" },
  { key: "Unknown", label: "Unknown", fullLabel: "No Notes Recorded", minDays: -1, maxDays: -1, color: "#6B7280" }
];

// AI Companion quick prompts
export const CVC_AI_QUICK_PROMPTS = [
  {
    id: "weekly-cvc-insights",
    icon: "📊",
    label: "This week's Purview CVC Customer Insights",
    prompt: `Purview CVC Weekly Insights

Analyze the Purview CVC customer engagement data and provide:

1. **Executive Summary** - Key metrics and highlights
2. **Solution Adoption** - Which Purview products have the most active engagements
3. **CVC Lead Distribution** - Workload across CVC leads
4. **Recent Activity** - Customers engaged in the past 7 days
5. **Attention Needed** - Customers with no recent engagement

Focus on actionable insights for this week.`
  },
  {
    id: "engagement-hygiene",
    icon: "🔍",
    label: "Engagements Hygiene",
    prompt: `Engagement Hygiene Analysis

Review the Purview CVC engagement data and identify:

1. **Stale Engagements** - Customers not contacted in 30+ days
2. **Missing Information** - Engagements with incomplete data
3. **Follow-up Needed** - Customers requiring attention based on last contact
4. **Workload Balance** - CVC leads who may need support

Provide specific recommendations for data quality improvement.`
  }
];
